import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=ce653dee&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce653dee')) {
      api.createRecord('ce653dee', component.options)
    } else {
      api.reload('ce653dee', component.options)
    }
    module.hot.accept("./ToolBar.vue?vue&type=template&id=ce653dee&", function () {
      api.rerender('ce653dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/partials/ToolBar.vue"
export default component.exports